






/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EchartOption from '@/common/const/e-chart-options';

@Component({
  components: {}
})
export default class RevenueDataLine extends Vue {
  options: EchartOption = new EchartOption();
  isData: boolean = true;

  @Prop()
  chartData!: any; //图表数据

  get title() {
    return {
      show: false
    };
  }

  get toolTip() {
    return {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    };
  }

  get grid() {
    return {
      top: '10',
      left: 0,
      right: '4%',
      bottom: 0,
      containLabel: true
    };
  }

  get legend() {
    return {
      show: false,
      orient: 'vertical',
      left: 10,
      data: this.chartData.legendData //['微信', '现金', '支付宝', '其他'],
    };
  }

  get series() {
    return [
      {
        name: '临停支付渠道',
        type: 'pie',
        radius: ['50%', '60%'],
        avoidLabelOverlap: true,
        label: {
          show: true,
          position: 'outside',
          formatter: '{d}%'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '14',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: true,
          length: 0,
          length2: 10
        },
        data: this.chartData.seriesData,
        // data: [
        //   { value: 335, name: '微信' },
        //   { value: 310, name: '现金' },
        //   { value: 234, name: '支付宝' },
        //   { value: 135, name: '其他' },
        // ],
        animation: true,
        animationType: 'expansion',
        animationDuration: '3000'
      }
    ];
  }

  async fetchChartData() {
    // try {
    //   const { data } = await api.queryAbnormalStatistics(param)
    //   // todo 临时屏蔽
    //   let data2 = data.filter(i => i.name != '跟车出场' && i.name != '被冲出场')
    //   this.seriesBarData = data2.map(i => i.num)
    //   this.yAxisData = data2.map(i => i.name)
    // } catch (e) {
    //   console.log(e)
    // } finally {
    //   this.refreshChart()
    // }
  }

  get graphic() {
    return [
      {
        type: 'text',
        left: 'center',
        top: '45%',
        style: {
          fill: '#AFC8FF',
          text: '支付渠道',
          fontSize: '12'
        }
      }
    ];
  }
  refreshChart() {
    const options: EchartOption = new EchartOption();
    options.setLegend(this.legend);
    options.setGrid(this.grid);
    // options.setXAxis(this.xAxis, true)
    // options.setYAxis(this.yAxis, true)
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setTooltip(this.toolTip);
    options.setGraphic(this.graphic);
    options.setColor(['#ff6e59', '#57FFC5', '#47A2FF', '#f6cf37']);
    // options.animationDuration = 10000
    // options.animationEasing = 'elasticOut'
    this.options = options;
  }

  init() {
    // this.fetchChartData()
  }

  mounted() {
    //this.refreshChart()
    // this.init()
  }
}
